import React from 'react';

import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Box from '@mui/material/Box';

import Typography from '@ts-core/components/Typography';
import { EMPTY_SPACE } from '@ts-core/utils/Constants';
import { CoreFillInTheBlanksQuestion, CoreFillInTheBlanksQuestionOption } from '../../types';

interface FillInTheBlanksQuestionTextProps<TQuestion extends CoreFillInTheBlanksQuestion> {
  question?: TQuestion;
  loading?: boolean;

  renderBlank: (blank: CoreFillInTheBlanksQuestionOption, blankIndex: number) => React.ReactNode;
}

const FillInTheBlanksQuestionText = <TQuestion extends CoreFillInTheBlanksQuestion>(props: FillInTheBlanksQuestionTextProps<TQuestion>) => {
  const { question, loading, renderBlank } = props;
  const chunks = question?.text;

  if (loading) {
    return (
      <Typography loading={loading} skeletonProps={{ lines: 3, lastLineWidth: '25%' }}>
        Loading
      </Typography>
    );
  }
  return (
    <FormControl component="fieldset" sx={{ m: 2 }}>
      <FormLabel component="legend" sx={{ mb: 2, lineHeight: 1.4 }}>
        <Box display="flex" flexDirection="row" flexWrap="wrap">
          {chunks?.map((chunk, index) => {
            if (index % 2 === 0) {
              return (
                <Box display="inline-block" mb={2} key={index}>
                  {chunk === EMPTY_SPACE ? '' : chunk}
                </Box>
              );
            }
            const blankIndex = Math.floor(index / 2);
            const blank = question?.options?.[blankIndex];

            return (
              <Box display="flex" flexDirection="row" sx={{ marginLeft: '3px', marginRight: '3px' }} key={index}>
                {renderBlank(blank!, blankIndex)}
              </Box>
            );
          })}
        </Box>
      </FormLabel>
    </FormControl>
  );
};

export default FillInTheBlanksQuestionText;
